module.exports = __webpack_public_path__ + "static/index/img/baikal-807.81689e67.jpg";